import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const About = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: '/assets/icons/flexibility.svg',
      title: 'Flexibility',
      description: 'Services when you need them, with no long-term commitments.'
    },
    {
      icon: '/assets/icons/efficiency.svg',
      title: 'Efficiency',
      description: 'A network of dependable drivers and couriers at your fingertips.'
    },
    {
      icon: '/assets/icons/security.svg',
      title: 'Security',
      description: 'Fully traceable transactions with live tracking & enhanced security.'
    }
  ];

  return (
    <section id="about-us" className="bg-gray-100 pb-20">
      {/* Background Text Container - Hidden on mobile, responsive on larger screens */}
      <div className="hidden md:block h-[120px] lg:h-[200px] relative overflow-hidden">
        <h2 className="text-[120px] lg:text-[180px] font-bold select-none whitespace-nowrap bg-gradient-to-b from-[#E0E0E0] to-transparent bg-clip-text text-transparent absolute top-0 left-1/2 -translate-x-1/2 w-full text-center">
          ABOUT JACKS
        </h2>
      </div>

      {/* Main Content */}
      <div className="container mt-1 mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          {/* Left Content */}
          <div>
            <motion.h2 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-3xl md:text-5xl font-bold leading-tight mb-8 mt-16 md:mt-0"
            >
              Empowering Individuals
              <br />
              And Businesses With
              <br />
              Seamless On-Demand
              <br />
              Solutions.
            </motion.h2>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="flex items-center gap-3 cursor-pointer group"
              onClick={() => navigate('/about')}
            >
              <span className="text-lg custom-font">Learn More</span>
              <img 
                src="/assets/icons/right-arrow.svg" 
                alt="right arrow" 
                className="w-15 h-15 transition-transform duration-300 group-hover:translate-x-1"
              />
            </motion.div>
          </div>

          {/* Right Content */}
          <div className="space-y-12">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-gray-600 text-lg"
            >
              At Jacks, we believe in making life easier without sacrificing quality or flexibility. As a premier on-demand service marketplace, we specialize in connecting users with trusted drivers and courier services tailored to their unique needs.
            </motion.p>

            <div className="grid grid-cols-3 gap-8">
              {features.map((feature, index) => (
                <motion.div
                  key={feature.title}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                  className="text-center"
                >
                  <div className="bg-white rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center shadow-lg">
                    <img src={feature.icon} alt={feature.title} className="w-8 h-8" />
                  </div>
                  <h3 className="font-semibold mb-2">{feature.title}</h3>
                  <p className="text-gray-600 text-sm">{feature.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 